import "./header.css";
import { Link } from "react-router-dom";
import { authSelector } from "../../store/selectors/index";
import { useSelector } from "react-redux";
import { glPosting } from "../../api/endpoints/allReports";
import { message, Spin, Modal, DatePicker } from "antd";
import { useState } from "react";
import dayjs from "dayjs";

const Header = () => {
  const { user, access_token } = useSelector(authSelector);

  const [isLoading, setIsLoading] = useState(false);

  // =========================================================
  // GL POSTING DATE MODAL
  // =========================================================
  const [isGLPostingModalOpen, setIsGLPostingModalOpen] = useState(false);

  const [glPostingDate, setGLPostingDate] = useState(dayjs());

  // =========================================================
  // OPEN GL POSTING MODAL
  // =========================================================
  const openGLPostingModal = () => {
    setGLPostingDate(dayjs());
    setIsGLPostingModalOpen(true);
  };

  // =========================================================
  // GL POSTING
  // =========================================================
  const editHandler = async () => {
    if (isLoading) return;

    if (!glPostingDate) {
      message.error("Please select a date");
      return;
    }

    const data = {
      siteId: user.siteId,
      enteredOn: glPostingDate.format("YYYY-MM-DD"),
    };

    setIsLoading(true);

    try {
      const results = await glPosting(data, access_token);

      if (results.data?.length === 0) {
        message.error("No Record Found on this date");
        return;
      }

      if (results.success) {
        message.success(
          results.message || "Successfully entered!"
        );

        // Close date popup
        setIsGLPostingModalOpen(false);
      } else {
        message.error(
          results.message || "Failed!"
        );
      }

    } catch (error) {
      message.error("GL Posting failed!");
      console.error(error);

    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* =====================================================
          FULL SCREEN LOADER
      ===================================================== */}

      {isLoading && (
        <div className="fullScreenLoader">
          <Spin size="large" />

          <div className="loaderText">
            GL Posting in progress...
          </div>

          <div className="loaderSubText">
            Please wait. Do not close or click anywhere.
          </div>
        </div>
      )}

      {/* =====================================================
          GL POSTING DATE MODAL
      ===================================================== */}

      <Modal
        title="GL Posting"
        open={isGLPostingModalOpen}
        onCancel={() => {
          if (!isLoading) {
            setIsGLPostingModalOpen(false);
          }
        }}
        onOk={editHandler}
        okText="Post GL"
        cancelText="Cancel"
        confirmLoading={isLoading}
        maskClosable={!isLoading}
        closable={!isLoading}
      >
        <div className="py-4">

          <label className="block mb-2 font-medium">
            Select Date
          </label>

          <DatePicker
            value={glPostingDate}
            onChange={(date) => {
              setGLPostingDate(date);
            }}
            format="DD-MM-YYYY"
            className="w-full"
            size="large"
            disabled={isLoading}
          />

        </div>
      </Modal>

      {/* =====================================================
          HEADER
      ===================================================== */}

      <div className="fontHeading pt-1 pb-4 text-white">
        <h3 className="mt-6 ml-14">
          Site Management System (Sales,Inventory and Accounts System)
        </h3>
      </div>

      {/* =====================================================
          NAVIGATION
      ===================================================== */}

      <div className="navR z-10 menu-bar w-full text-white pt-2 pb-3">

        <ul className="ml-14 w-3/5 flex justify-between cursor-pointer">

          {/* =================================================
              FILE
          ================================================= */}

          <li className="hover:bg-blue-500 p-2">
            File
          </li>

          {/* =================================================
              DATA STORAGE
          ================================================= */}

          <li className="hover:bg-blue-500 p-2">

            Data Storage

            <div className="dropdown-menu">

              <ul>

                {user.role === "admin" && (

                  <Link to="/registerUser">

                    <li className="hover:bg-blue-500 text-white">
                      New User
                    </li>

                  </Link>

                )}

              </ul>

            </div>

          </li>

          {/* =================================================
              REPORTS
          ================================================= */}

          <li className="hover:bg-blue-500 p-2">

            Reports

            <div className="dropdown-menu">

              <ul>

                {/* =========================================
                    DAILY TRANSACTION
                ========================================= */}

                <li className="hover:bg-blue-500 text-white">

                  Daily Transaction

                  <div className="dropdown-menu-1">

                    <ul>

                      <li className="hover:bg-blue-500 text-white">

                        Sales

                        <div className="dropdown-menu-1">

                          <ul>

                            <Link to="/creditSaleSheetEntryWise">

                              <li className="hover:bg-blue-500 text-white">
                                Credit Sale Sheet Entry Wise
                              </li>

                            </Link>

                            <Link to="/creditSaleSheetCustomerVehicleWise">

                              <li className="hover:bg-blue-500 text-white">
                                Customer + Vehicle Wise Sheet
                              </li>

                            </Link>

                          </ul>

                        </div>

                      </li>

                    </ul>

                  </div>

                </li>

                {/* =========================================
                    CUSTOMER / SUPPLIER
                ========================================= */}

                <li className="hover:bg-blue-500 text-white">

                  Customer/Supplier Account

                  <div className="dropdown-menu-1">

                    <ul>

                      <Link to="/PLedger">

                        <li className="hover:bg-blue-500 text-white">
                          Party Ledger
                        </li>

                      </Link>

                    </ul>

                  </div>

                </li>

                {/* =========================================
                    STOCK
                ========================================= */}

                <li className="hover:bg-blue-500 text-white">

                  Stock

                  <div className="dropdown-menu-1">

                    <ul>

                      <Link to="/stockBalance">

                        <li className="hover:bg-blue-500 text-white">
                          Stock Balance
                        </li>

                      </Link>

                      <Link to="/purchaseRegister">

                        <li className="hover:bg-blue-500 text-white">
                          Purchase Register
                        </li>

                      </Link>

                      <Link to="/saleRegister">

                        <li className="hover:bg-blue-500 text-white">
                          Sale Register
                        </li>

                      </Link>

                      <Link to="/bulkSaleRegister">

                        <li className="hover:bg-blue-500 text-white">
                          Bulk Sale Register
                        </li>

                      </Link>

                      <Link to="/bulkSalePurchaseReg">

                        <li className="hover:bg-blue-500 text-white">
                          Bulk Sale Purchase Register
                        </li>

                      </Link>

                      <Link to="/saleTaxInv">

                        <li className="hover:bg-blue-500 text-white">
                          Sale Tax Inv
                        </li>

                      </Link>

                      <Link to="/stockSummaryRateWise">

                        <li className="hover:bg-blue-500 text-white">
                          Stock Summary
                        </li>

                      </Link>

                    </ul>

                  </div>

                </li>

                {/* =========================================
                    MANAGEMENT
                ========================================= */}

                <li className="hover:bg-blue-500 text-white">

                  Management

                  <div className="dropdown-menu-1">

                    <ul>

                      <Link to="/stockRegister">

                        <li className="hover:bg-blue-500 text-white">
                          Fuel Sale Stock Register
                        </li>

                      </Link>

                    </ul>

                  </div>

                </li>

                {/* =========================================
                    INVOICES
                ========================================= */}

                <li className="hover:bg-blue-500 text-white">

                  Invoices and Summary

                  <div className="dropdown-menu-1">

                    <ul>

                      <Link to="/partyWiseBill">

                        <li className="hover:bg-blue-500 text-white">
                          Party Bill Vehicle Wise
                        </li>

                      </Link>

                      <Link to="/customerBSummary">

                        <li className="hover:bg-blue-500 text-white">
                          Customer Bill Summary
                        </li>

                      </Link>

                      <Link to="/customerIWise">

                        <li className="hover:bg-blue-500 text-white">
                          Customer B/S Item Wise
                        </li>

                      </Link>

                      <Link to="/partyWiseBillBulk">

                        <li className="hover:bg-blue-500 text-white">
                          Bulk Bill
                        </li>

                      </Link>

                      <Link to="/partyWiseBillBulkSummary">

                        <li className="hover:bg-blue-500 text-white">
                          Bulk Bill Summary
                        </li>

                      </Link>

                    </ul>

                  </div>

                </li>

              </ul>

            </div>

          </li>

          {/* =================================================
              ADMIN
          ================================================= */}

          <li className="hover:bg-blue-500 p-2">
            Admin
          </li>

          {/* =================================================
              HELP
          ================================================= */}

          <li className="hover:bg-blue-500 p-2">
            Help
          </li>

          {/* =================================================
              ACCOUNTS
          ================================================= */}

          <li className="hover:bg-blue-500 p-2">

            Accounts

            <div className="dropdown-menu">

              {/* =============================================
                  ACCOUNTS REPORTS
              ============================================= */}

              <ul>

                <li className="hover:bg-blue-500 text-white">

                  Accounts Reports

                  <div className="dropdown-menu-1">

                    <ul>

                      <Link to="/GLedger">

                        <li className="hover:bg-blue-500 text-white">
                          General Ledger
                        </li>

                      </Link>

                      <Link to="/vehicleExp">

                        <li className="hover:bg-blue-500 text-white">
                          Vehicle Expense
                        </li>

                      </Link>

                      <Link to="/stockOrder">

                        <li className="hover:bg-blue-500 text-white">
                          Stock Order
                        </li>

                      </Link>

                      <Link to="/expRprt">

                        <li className="hover:bg-blue-500 text-white">
                          Monthly Exp Report
                        </li>

                      </Link>

                      <Link to="/trialBalance">

                        <li className="hover:bg-blue-500 text-white">
                          Trial Balance
                        </li>

                      </Link>

                      <Link to="/profitLossReport">

                        <li className="hover:bg-blue-500 text-white">
                          Profit & Loss
                        </li>

                      </Link>

                      <Link to="/dailySheetNonPDFReport">

                        <li className="hover:bg-blue-500 text-white">
                          Daily Sheet
                        </li>

                      </Link>

                      <Link to="/logSheetReport">

                        <li className="hover:bg-blue-500 text-white">
                          Log Sheet
                        </li>

                      </Link>

                      <Link to="/tankLorryReport">

                        <li className="hover:bg-blue-500 text-white">
                          Tank Lorry Report
                        </li>

                      </Link>

                      <Link to="/rateGainReport">

                        <li className="hover:bg-blue-500 text-white">
                          Rate G/L
                        </li>

                      </Link>

                      <Link to="/dayBook">

                        <li className="hover:bg-blue-500 text-white">
                          Day Book
                        </li>

                      </Link>

                    </ul>

                  </div>

                </li>

              </ul>

              {/* =============================================
                  VERIFICATION
              ============================================= */}

              <ul>

                <li className="hover:bg-blue-500 text-white">

                  Verification

                  <div className="dropdown-menu-1">

                    <ul>

                      <Link to="/pendingApprovals">

                        <li className="hover:bg-blue-500 text-white">
                          Pending Approvals
                        </li>

                      </Link>

                    </ul>

                  </div>

                </li>

              </ul>

              {/* =============================================
                  GL POSTING
              ============================================= */}

              <ul>

                <li
                  className="hover:bg-blue-500 text-white cursor-pointer"
                  onClick={openGLPostingModal}
                >
                  GL POSTING
                </li>

              </ul>

            </div>

          </li>

          {/* =================================================
              DAY DATA
          ================================================= */}

          <li className="hover:bg-blue-500 p-2">
            Day Data
          </li>

          {/* =================================================
              DAY REPORTS
          ================================================= */}

          <li className="hover:bg-blue-500 p-2">
            Day Reports
          </li>

        </ul>

      </div>
    </>
  );
};

export default Header;
